/**
 * Зависимости
 */
import type {IYandexMap, IYandexMapFilter} from '@/components/yandex-map/types';
import {EBreakpoint} from '@/common/scripts/constants';
import type {IObserver} from '@/common/scripts/types/observer';
import type {IRouteData} from '@/components/yandex-map/types';
import MapFilter from '@/components/yandex-map/infrastructure-checkbox-filter';
import MapRoutes from '@/components/map-routes';
import Observer from '@/common/scripts/observer';
import {RESIZE_EVENTS} from '@/common/scripts/constants';
import {Utils} from '@/common/scripts/utils';
import YandexMap from '@/components/yandex-map';

const observer: IObserver = new Observer();

/**
 * Карта в блоке Расположение
 */
// eslint-disable-next-line max-lines-per-function
export const initLocationMap = (wrapper: HTMLElement): void => {
    const commonMap: Element | null = wrapper.querySelector('.j-popup-map');

    let yandexMap: IYandexMap | null = null;
    let mapRoutes: any | null = null;
    let isMobile: boolean = Utils.getWindowWidth() < EBreakpoint.TABLET_PORTRAIT;

    RESIZE_EVENTS.forEach((event: string): void => {
        window.addEventListener(event, (): void => {
            isMobile = Utils.getWindowWidth() < EBreakpoint.TABLET_PORTRAIT;
        });
    });

    if (commonMap) {
        const initMap = (): void => {
            const ymaps = window.ymaps;

            ymaps.ready((): void => {
                yandexMap = new YandexMap(ymaps);
                yandexMap.init({
                    wrapper                : commonMap as HTMLElement,
                    cluster                : true,
                    customZoomControl      : true,
                    disableMobileDrag      : true,
                    fullScreenControl      : false,
                    customFullScreenControl: false
                });

                observer.subscribe('map:setRoute', (data: IRouteData): void => {
                    yandexMap?.setRoute(data);
                });
            });
        };

        Utils.checkMap(initMap);
    }

    const mapFilterWrapper: Element | null = wrapper.querySelector('.j-map-filter');

    if (mapFilterWrapper) {
        const mapFilter: IYandexMapFilter = new MapFilter();

        mapFilter.init({
            target: mapFilterWrapper as HTMLElement
        });
    }

    const routeList = wrapper.querySelector('.j-map-routes');

    if (routeList) {
        mapRoutes = new MapRoutes();

        mapRoutes.init({
            target: routeList
        });
    }

    const controlsWrapper = wrapper.querySelector('.j-map-controls');
    const filterListButton = controlsWrapper?.querySelector('.j-map-filter-list-open');
    const filterList = wrapper.querySelector('.j-map-filter-list');
    const closeFilterListButton = filterList?.querySelector('.j-map-filter-list-close');
    const routeButton = controlsWrapper?.querySelector('.j-map-route-open');
    const closeRouteListButton = routeList?.querySelector('.j-map-route-close');
    const activeClass = 'is-active';
    const disableClass = 'is-hidden';
    const openClass = 'is-filter-open';

    const removeRoute = (): void => {
        if (yandexMap) {
            yandexMap.removeRoute();
            yandexMap.showAllMarkers();
            if (yandexMap.settings.center && yandexMap.settings.zoom) {
                yandexMap.setCenter(yandexMap.settings.center, yandexMap.settings.zoom);
            }
        }
        if (mapRoutes) {
            mapRoutes.removeActiveState();
        }
    };

    // Открытие фильтра инфраструктуры
    if (controlsWrapper && filterListButton && filterList) {
        filterListButton.addEventListener('click', () => {
            controlsWrapper.classList.add(disableClass);
            filterList.classList.add(activeClass);
            if (commonMap) {
                commonMap.classList.add(openClass);
            }
            if (isMobile) {
                removeRoute();
            }
        });
    }

    // Закрытие фильтра инфраструктуры
    if (controlsWrapper && closeFilterListButton && filterList) {
        closeFilterListButton.addEventListener('click', () => {
            filterList.classList.remove(activeClass);
            controlsWrapper.classList.remove(disableClass);
            if (commonMap) {
                commonMap.classList.remove(openClass);
            }
        });
    }

    // Открытие фильтра маршрутов
    if (controlsWrapper && routeButton && routeList) {
        routeButton.addEventListener('click', () => {
            controlsWrapper.classList.add(disableClass);
            routeList.classList.add(activeClass);
            if (commonMap) {
                commonMap.classList.add(openClass);
            }
            if (yandexMap) {
                yandexMap.hideAllMarkers();
            }
        });
    }

    // Закрытие фильтра маршрутов
    if (controlsWrapper && closeRouteListButton && routeList) {
        closeRouteListButton.addEventListener('click', async() => {
            routeList.classList.remove(activeClass);
            controlsWrapper.classList.remove(disableClass);
            if (commonMap) {
                commonMap.classList.remove(openClass);
            }
            if (!isMobile || (isMobile && mapRoutes && !mapRoutes.isSet)) {
                await removeRoute();
            }
        });
    }
};
